module.exports={
  "_args": [
    [
      "pacote@8.1.6",
      "C:\\Projects\\TBF\\Source"
    ]
  ],
  "_from": "pacote@8.1.6",
  "_id": "pacote@8.1.6",
  "_inBundle": true,
  "_integrity": "sha512-wTOOfpaAQNEQNtPEx92x9Y9kRWVu45v583XT8x2oEV2xRB74+xdqMZIeGW4uFvAyZdmSBtye+wKdyyLaT8pcmw==",
  "_location": "/npm/pacote",
  "_phantomChildren": {},
  "_requested": {
    "type": "version",
    "registry": true,
    "raw": "pacote@8.1.6",
    "name": "pacote",
    "escapedName": "pacote",
    "rawSpec": "8.1.6",
    "saveSpec": null,
    "fetchSpec": "8.1.6"
  },
  "_requiredBy": [
    "/npm",
    "/npm/libcipm"
  ],
  "_resolved": "https://registry.npmjs.org/pacote/-/pacote-8.1.6.tgz",
  "_spec": "8.1.6",
  "_where": "C:\\Projects\\TBF\\Source",
  "author": {
    "name": "Kat Marchán",
    "email": "kzm@sykosomatic.org"
  },
  "bugs": {
    "url": "https://github.com/zkat/pacote/issues"
  },
  "contributors": [
    {
      "name": "Charlotte Spencer",
      "email": "charlottelaspencer@gmail.com"
    },
    {
      "name": "Rebecca Turner",
      "email": "me@re-becca.org"
    }
  ],
  "dependencies": {
    "bluebird": "^3.5.1",
    "cacache": "^11.0.2",
    "get-stream": "^3.0.0",
    "glob": "^7.1.2",
    "lru-cache": "^4.1.3",
    "make-fetch-happen": "^4.0.1",
    "minimatch": "^3.0.4",
    "minipass": "^2.3.3",
    "mississippi": "^3.0.0",
    "mkdirp": "^0.5.1",
    "normalize-package-data": "^2.4.0",
    "npm-package-arg": "^6.1.0",
    "npm-packlist": "^1.1.10",
    "npm-pick-manifest": "^2.1.0",
    "osenv": "^0.1.5",
    "promise-inflight": "^1.0.1",
    "promise-retry": "^1.1.1",
    "protoduck": "^5.0.0",
    "rimraf": "^2.6.2",
    "safe-buffer": "^5.1.2",
    "semver": "^5.5.0",
    "ssri": "^6.0.0",
    "tar": "^4.4.3",
    "unique-filename": "^1.1.0",
    "which": "^1.3.0"
  },
  "description": "JavaScript package downloader",
  "devDependencies": {
    "nock": "^9.2.6",
    "npmlog": "^4.1.2",
    "nyc": "^11.8.0",
    "require-inject": "^1.4.3",
    "standard": "^11.0.1",
    "standard-version": "^4.4.0",
    "tacks": "^1.2.6",
    "tap": "^12.0.1",
    "tar-stream": "^1.6.1",
    "weallbehave": "^1.2.0",
    "weallcontribute": "^1.0.7"
  },
  "files": [
    "*.js",
    "lib"
  ],
  "homepage": "https://github.com/zkat/pacote#readme",
  "keywords": [
    "packages",
    "npm",
    "git"
  ],
  "license": "MIT",
  "main": "index.js",
  "name": "pacote",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/zkat/pacote.git"
  },
  "scripts": {
    "postrelease": "npm publish && git push --follow-tags",
    "prerelease": "npm t",
    "pretest": "standard",
    "release": "standard-version -s",
    "test": "nyc --all -- tap -J test/*.js",
    "test-docker": "docker run -it --rm --name pacotest -v \"$PWD\":/tmp -w /tmp node:latest npm test",
    "update-coc": "weallbehave -o . && git add CODE_OF_CONDUCT.md && git commit -m 'docs(coc): updated CODE_OF_CONDUCT.md'",
    "update-contrib": "weallcontribute -o . && git add CONTRIBUTING.md && git commit -m 'docs(contributing): updated CONTRIBUTING.md'"
  },
  "version": "8.1.6"
}
